import { Controller } from '@hotwired/stimulus'
import 'chart.js/auto' // ensure Chart.js components are registered in the portal bundle
import { buildChart } from '../shared/shared_report_chart'

// Renders a single <canvas data-chart ...> in the AUTHENTICATED portal (the
// create-form preview) so the preview's charts match the public recipient view
// exactly. The public page builds the same canvases via the slim pack's
// initializer instead; the slim pack starts no Stimulus, so this controller's
// data-controller attr is inert there (no double render).
//
// Phase 3 C — lazy-render: build the chart only when the canvas scrolls into
// view (perf on long full_event_report pages). Falls back to eager build where
// IntersectionObserver is unavailable. Parity with the public slim pack via the
// shared buildChart (C6). The preview frame re-renders on each load, so destroy
// the chart + observer on disconnect to avoid "Canvas already in use".
export default class extends Controller {
  connect() {
    if (typeof IntersectionObserver === 'undefined') {
      this._chart = buildChart(this.element)
      return
    }
    this._observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this._chart = buildChart(this.element)
          obs.unobserve(this.element)
        }
      })
    }, { rootMargin: '200px' })
    this._observer.observe(this.element)
  }

  disconnect() {
    if (this._observer) { this._observer.disconnect(); this._observer = null }
    if (this._chart && typeof this._chart.destroy === 'function') this._chart.destroy()
    this._chart = null
  }
}
